import { useApiClient } from '@siclop/kstone-vue'
import type { ProjectMember } from '../models/ProjectMember'

interface MembreRequest {
  employeeId: number
  isProjectManager: boolean
}

/**
 * Membres d'un projet (API `projects/{projectId}/members`, T55). Lecture : VIEW_PROJECT ; ajout, modification et
 * retrait : EDIT_PROJECT et être chef du projet (403 sinon).
 */
export class ProjectMemberService {
  private static url(projectId: number) {
    return `/projects/${projectId}/members`
  }

  static async getAll(projectId: number): Promise<ProjectMember[]> {
    return useApiClient().get<ProjectMember[]>(this.url(projectId))
  }

  static async add(projectId: number, employeeId: number, isProjectManager: boolean): Promise<ProjectMember> {
    return useApiClient().postRaw<MembreRequest, ProjectMember>(this.url(projectId), { employeeId, isProjectManager })
  }

  static async setProjectManager(projectId: number, member: ProjectMember, isProjectManager: boolean): Promise<ProjectMember> {
    return useApiClient().putRaw<MembreRequest, ProjectMember>(`${this.url(projectId)}/${member.id}`,
      { employeeId: member.employeeId, isProjectManager })
  }

  /** Désigne le PO du projet (null : aucun PO). Chef du projet seulement ; le PO doit être membre du projet (400 sinon). */
  static async setProductOwner(projectId: number, employeeId: number | null): Promise<ProjectMember[]> {
    return useApiClient().putRaw<{ employeeId: number | null }, ProjectMember[]>(`/projects/${projectId}/product-owner`, { employeeId })
  }

  static async remove(projectId: number, memberId: number): Promise<void> {
    await useApiClient().delete(`${this.url(projectId)}/${memberId}`)
  }
}
